import { BasicDto } from "../../_shared/models/basicDto";

export class Federations {
  static Formaat: number = 1;
  static VlaamseZwemfederatie: number = 2;
  static Vlamo: number = 3;
  static SCWITCH: number = 4;
  static Andere: number = 999;
  static ChirojeugdVlaanderen: number = 1006;
  static KLJ: number = 1007;
  static KoorEnStem: number = 1008;
  static ThomasMoreGeel: number = 1009;
  static SkateVlaanderen: number = 1010;
  static Roots: number = 1011;
  static VlaamseGemeenschapscommissie: number = 1012;
  static VlaamseSportfederatie: number = 1013;
  static SportdienstVGC: number = 1018;
  static VlaamsSteunpuntVrijwilligerswerk: number = 1019;
  static VogelbeschermingVlaanderen: number = 1020;
  static Buurtsecretariaten: number = 1021;
  static DistrictBorgerhout: number = 1027;
  static LokaalBestuurGenk: number = 1028;
  static StadKortrijk: number = 1029;
  static LokaleBesturen: number = 1030;
  static LokaalBestuurSintGillisWaas: number = 1031;
}

export interface FederationBasicDto extends BasicDto<number> {
  NameShort: string | null;
  Street: string;
  Number: string;
  PostalCode: string;
  City: string;
  Country: string;
  VAT: string;
  EmailAddress: string;
  PhoneNumber: string;
  LicenceDeleteFrom: Date | null;
  LicenceDeleteTill: Date | null;
  GenerateMemberNumber: boolean | null;
  DefaultOrganizationTypeId: number | null;
  ShowOnAttest: boolean | null;
  default_reduction: number | null;
  FreeStartSubscription: boolean | null;
  CanOrderStartSubscription: boolean | null;
  ReductionStart: number | null;
  HideDate: boolean | null;
  DefaultStartDateId: number | null;
  DefaultEndDateId: number | null;
  OrganisationId: number | null;
  EnableFreeSubscription: boolean;
}
